(() => {
    'use strict';

    real.events.on('transcript:queued', notification => {
        if(!notification.object?.uploadedfile?.id) {
            return;
        }

        const uploadedFileId = notification.object.uploadedfile.id;
        const transcriptContainer = $(`.transcript-container[data-uploadedfile-id="${uploadedFileId}"]`);
        if (transcriptContainer.length === 0) {
            return;
        }

        if (transcriptContainer.hasClass('d-none')) {
            howspace.animate(transcriptContainer, 'slideDown', 350, () => {
                transcriptContainer.removeClass('d-none');
            });
        }

        transcriptContainer.find('.synopsis-wrapper').addClass('d-none');

        if (!transcriptContainer.find('.transcript-content-wrapper').hasClass('d-none')) {
            howspace.animate(transcriptContainer.find('.transcript-content-wrapper'), 'slideUp', 350, () => {
                transcriptContainer.find('.transcript-content-wrapper').addClass('d-none');
                howspace.animate(transcriptContainer.find('.transcript-progress-wrapper'), 'slideDown', 350, () => {
                    transcriptContainer.find('.transcript-progress-wrapper').removeClass('d-none');
                    transcriptContainer.find('.transcribe-label .howspace-form-label-text span').text(howspace.translate('transcript_transcribe_in_queued'));
                });
            });
        }
    });

})();
